import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { CheckCircle, Autorenew, RadioButtonUnchecked } from '@mui/icons-material';

export type JourneyStageState = 'done' | 'active' | 'pending';
export interface JourneyStage { label: string; state: JourneyStageState; }

const colors = { done: '#16a34a', active: '#2563eb', pending: '#94a3b8', line: '#e2e8f0' };

const dot = (s: JourneyStageState) => {
  if (s === 'done') return <CheckCircle sx={{ fontSize: 18, color: colors.done }} />;
  if (s === 'active') return <Autorenew sx={{ fontSize: 18, color: colors.active }} />;
  return <RadioButtonUnchecked sx={{ fontSize: 18, color: colors.pending }} />;
};

/**
 * Reusable business-journey strip: renders a transaction/entity lifecycle with
 * per-stage state (done / active / pending). Used on Order Fulfillment, Entity
 * 360 views, and any document that has a lifecycle.
 */
const BusinessJourney: React.FC<{ stages: JourneyStage[]; dense?: boolean }> = ({ stages, dense }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', overflowX: 'auto', py: dense ? 0.5 : 1 }}>
    {stages.map((st, i) => (
      <React.Fragment key={st.label}>
        <Stack alignItems="center" spacing={0.25} sx={{ minWidth: dense ? 66 : 84 }}>
          {dot(st.state)}
          <Typography sx={{ fontSize: dense ? 10 : 11, color: st.state === 'pending' ? colors.pending : 'text.primary', fontWeight: st.state === 'active' ? 700 : 500 }}>{st.label}</Typography>
        </Stack>
        {i < stages.length - 1 && (
          <Box sx={{ flex: 1, height: 2, minWidth: 14, bgcolor: st.state === 'done' ? colors.done : colors.line }} />
        )}
      </React.Fragment>
    ))}
  </Box>
);

export default BusinessJourney;
